export interface Currency {
    code: string;
    symbol: string;
    created_at: string;
    exchange_rate: string;
    id: number;
    name: string;
    primary: boolean;
    updated_at: string;
}
